export default {
    //WhatsApp
    WhatsAppFlows: [],
    WhatsAppAccounts: [],
    WhatsAppTemplates: [],
    ActiveWhatsAppAccount: {},
    WhatsAppBroadcasts: [],
    WhatsAppSequences: [],    
}